
const data = {
  data: {
    me: {
      id: 5,
      name: 'Fatima Franecki',
      surname: 'Colt Will',
      status_id: 0,
      lang_code: 'es',
      email: 'admin@fidery.es',
      email_verified_at: '2021-05-25T15:33:56.000000Z',
      birthday_date: '1966-06-12',
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:56.000000Z',
      deleted_at: null,
      cifnif: null
    },
    companies: [
      {
        id: 1,
        license_id: 15,
        name: 'Monahan LLC',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:56.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 2,
        license_id: 7,
        name: 'Weber, Lang and Nienow',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:57.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 3,
        license_id: 8,
        name: 'Hackett-Williamson',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:57.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 4,
        license_id: 16,
        name: 'Hahn, Kling and Johnson',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:57.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 5,
        license_id: 9,
        name: 'Goodwin, Metz and Powlowski',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:57.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 6,
        license_id: 14,
        name: 'Terry, McKenzie and Kling',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:57.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 7,
        license_id: 6,
        name: 'Wilkinson-Welch',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:57.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 8,
        license_id: 15,
        name: 'Bode Ltd',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:57.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 9,
        license_id: 7,
        name: 'Bernier, Homenick and Bergnaum',
        created_at: '2021-05-25T15:33:56.000000Z',
        updated_at: '2021-05-25T15:33:57.000000Z',
        deleted_at: null,
        user_provider: null,
        user_validation_rules: null,
        rules_customer_check: '{}',
        temporal_field_check: null
      },
      {
        id: 10,
        license_id: 1,
        name: 'Adarsa',
        created_at: null,
        updated_at: null,
        deleted_at: null,
        user_provider: 'AdarsaCustomer',
        user_validation_rules: '{"email": "required_without:cifnif|email|exists:100_adarsa_customers,email","cifnif": "required_without:email|string|exists:100_adarsa_customers,cifnif","plate": "required|string|exists:110_adarsa_products,plate"}',
        rules_customer_check: 'select * from 110_adarsa_products as ap left join 100_adarsa_customers as ac on ac.master_client = ap.master_client where ap.plate = :plate and (ac.email = :email or ac.cifnif = :cifnif)',
        temporal_field_check: null
      }
    ],
    business: [],
    legals: []
  }
}

export default data
